import * as React from 'react';
import { SVGProps } from 'react';
const SvgInformationCircleErrorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.75 18.75L18.8191 18.7154C19.7743 18.2378 20.8499 19.1006 20.5908 20.1366L19.4092 24.8634C19.1501 25.8994 20.2257 26.7622 21.1809 26.2846L21.25 26.25M35 20C35 28.2843 28.2843 35 20 35C11.7157 35 5 28.2843 5 20C5 11.7157 11.7157 5 20 5C28.2843 5 35 11.7157 35 20ZM20 13.75H20.0125V13.7625H20V13.75Z" stroke="#DC3545" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgInformationCircleErrorIcon;
